import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "../UpiForm.css";
import { fetchUPIQR } from "../../../../actions/upi";

export const UpiIntent = ({ charge, dispatch }) => {
  const { uuid } = charge;

  function callUpiIntent() {
    useEffect(() => {
      dispatch(fetchUPIQR(uuid, "true"));
    }, []);
  }

  return <form onLoad={callUpiIntent()} />;
};

UpiIntent.propTypes = {
  charge: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    testMode: PropTypes.bool.isRequired
  }).isRequired,
  dispatch: PropTypes.func.isRequired
};

UpiIntent.defaultProps = {};

function mapStateToProps({ upiReducer }) {
  return upiReducer;
}

export default connect(mapStateToProps)(UpiIntent);
